import { eventsApi, highlightsApi } from "store/api"
import { GalleryMedium } from "features/gallery/gallery.types"
import { UploadedFile } from "suus-api"

export async function addGalleyMediumToHighlights(
  eventId: number,
  galleryMediumId: number
) {
  const response = await highlightsApi.addHighlight(eventId.toString(), {
    event_medium_id: galleryMediumId,
    send_to_back: true,
  })
  return response.data
}

export async function removeHighlight(gallery: GalleryMedium) {
  if (!gallery.highlight_id) return

  await highlightsApi.removeFromHighlights(gallery.highlight_id.toString())
  return
}

export async function getHighlights(
  eventId: number,
  offset: number,
  limit: number
) {
  const response = await highlightsApi.getHighlights(
    eventId.toString(),
    offset,
    limit,
    "asc"
  )
  return response.data
}

export async function getHighlightsGalleryMedia(
  eventId: number,
  offset: number,
  limit: number
) {
  const response = await getHighlights(eventId, offset, limit)
  return response.map((highlight) => highlight.event_medium)
}

export async function setFeaturedImage(
  eventId: number,
  uploaded_file: UploadedFile
) {
  await eventsApi.updateEvent(eventId.toString(), {
    featured_image_id: uploaded_file.id,
  })
}

export async function reorderHighlights({
  id,
  index,
}: {
  id: number
  index: number
}) {
  await highlightsApi.updateHighlight(id.toString(), { index: index })
}
